import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  textContainer: {
    paddingLeft: theme.spacing.space24,
    paddingRight: theme.spacing.space24,
    paddingTop: theme.spacing.space20,
    textAlign: "center",
  },
  description: {
    marginTop: theme.spacing.space12,
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
  },
}));
